import { instance as axiosInstance } from './instance';
const API_URL = 'http://localhost:7070/';
export const botActions = _ref => {
  let {
    apiUri = API_URL,
    token
  } = _ref;
  return {
    // loadAvailableBotConversationList: async (
    //   botId: string = BOT_ID,
    // ): Promise<IBoConversationList> => {
    //   const getConversationId = await axiosInstance({
    //     method: 'POST',
    //     baseURL: apiUri,
    //     url: `bots/unrestricted/${botId}`,
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //     },
    //   });

    //   const conversationId = getConversationId?.headers?.location
    //     ?.split('/')
    //     ?.pop();

    //   const data = {
    //     data: {
    //       loadAvailableBotConversationList: [
    //         {
    //           id: conversationId,
    //           type: conversationId,
    //           audience: 'unknown',
    //           disabled: false,
    //           displayText: `Conversation ID: ${conversationId}`,
    //           displaySubText: 'Subtext',
    //           image: images.generalHowItWorks,
    //         },
    //       ],
    //     },
    //   };
    //   return data;
    // },
    getConversation: async _ref2 => {
      let {
        intent,
        userId
      } = _ref2;
      const {
        data
      } = (await axiosInstance({
        method: 'GET',
        baseURL: apiUri,
        url: `loadBotConversation/managedbots/${intent}/${userId}?language=en&returnDetailed=false&returnCurrentStepOnly=true&returningFields=conversationOutputs&returningFields=conversationQuickReplies`,
        // url: `managedbots/${intent}/${userId}?language=en&returnDetailed=false&returnCurrentStepOnly=true&returningFields=conversationOutputs&returningFields=conversationQuickReplies`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })) || {};
      return data;
    },
    updateConversation: async _ref3 => {
      let {
        intent,
        step,
        userId,
        organizationId
      } = _ref3;
      const {
        data
      } = (await axiosInstance({
        method: 'POST',
        baseURL: apiUri,
        url: `sendMessageToBot/managedbots/${intent}/${userId}${organizationId ? `/${organizationId}` : ''}?language=en&returnDetailed=false&returnCurrentStepOnly=true&returningFields=conversationOutputs&returningFields=conversationQuickReplies`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: {
          input: step,
          context: {
            userInfo: {
              type: 'object',
              value: {
                token
              }
            }
          }
        }
      })) || {};
      return data;
    },
    undoConversation: async _ref4 => {
      let {
        intent,
        userId
      } = _ref4;
      const {
        data
      } = (await axiosInstance({
        method: 'POST',
        baseURL: apiUri,
        url: `undoBotConversation/managedbots/${intent}/${userId}`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })) || {};
      return data;
    },
    resetConversation: async _ref5 => {
      let {
        intent,
        userId
      } = _ref5;
      await axiosInstance({
        method: 'POST',
        baseURL: apiUri,
        url: `resetBotConversation/managedbots/${intent}/${userId}`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    }
  };
};
//# sourceMappingURL=bo.js.map